<mode-day-of-week-selector
  [dayOfWeek]="schedule.dayOfTheWeek"
  (dayOfWeekChanged)="dayOfWeekChanged.emit($event)"
></mode-day-of-week-selector>
<mode-time-with-time-zone-selector
  [schedule]="schedule"
  (timeChanged)="timeChanged.emit($event)"
></mode-time-with-time-zone-selector>
